import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CopilotIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* GitHub Copilot icon - based on the official GitHub Copilot logo */}
    <path d="M23.922 16.992c-.861 1.495-5.859 5.023-11.922 5.023-6.063 0-11.061-3.528-11.922-5.023A.641.641 0 0 1 .078 16.5c0-.22.07-.427.922-.992C1.861 14.013 6.859 10.485 12.922 10.485s11.061 3.528 11.922 5.023c.852.565.922.772.922.992 0 .22-.07.427-.844.492zM9 12.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0z" />
    <path d="M12.922 5.5C6.859 5.5 1.861 1.972 1 .477A.641.641 0 0 0 .078.985c0 .22.07.427.922.992C1.861 2.472 6.859 5.5 12.922 5.5s11.061-3.028 11.922-4.523c.852-.565.922-.772.922-.992 0-.22-.07-.427-.844-.492C23.142 1.988 18.144 5.5 12.922 5.5z" />
    <circle cx="12" cy="16" r="2" />
  </SvgIcon>
);